/**
 * Created by rsxl-105 on 2018/6/13.
 */
export const voucherType = {
    // 设备请求
    DEVC_REQR: "devc.reqr",
    // 询盘单
    DEAL_INQRY: "deal.inqry",
    // 报盘单
    DEAL_REPLY: "deal.reply",
    // 询价单
    PRICE_INQRY: "price.inqry",
    // 报价单
    PRICE_REPLY: "price.reply",
    // 招标书
    CALL_BID: "call.bid",
    // 投标书
    TEND_BID: "tend.bid",
    // 合同
    CONTRACT: "contract",
    // 商品订单
    GOODS_ORDER: "goods.order",
    // 发货单
    GOODS_SHIP: "goods.ship",
    // 收货单
    GOODS_RECV: "goods.recv",
    // 服务请求单
    SERVC_REQR: "servc.reqr",
    // 服务订单
    SERVC_ORDER: "servc.order",
    // 服务派工单
    SERVC_WORK: "servc_work",
    // 支付单据
    PAY_VOUCHER: "pay.voucher",
    // 退款单据
    REFUND_VOUCHER: "refund.voucher"
};


//////////////////
// WEBPACK FOOTER
// ./resc/app/js/voucherType.js
// module id = 293
// module chunks = 0